export const inboundEntriesTableKeys = [
  {
    name: "Reference Code",
    key: "gmsReferenceCode",
  },
  {
    name: "Entered Date",
    key: "createdAt",
    isDate: true,
  },
  {
    name: "Received Date",
    key: "receivedDate",
    isDate: true,
  },
  {
    name: "Incoming Date",
    key: "incomingDate",
    isDate: true,
  },
  {
    name: "Warehouse code",
    path: "warehouse",
    key: "code",
  },

  {
    name: "Total Items",
    key: "totalItems",
  },
];
